
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

export interface Endtest {

    Id: string;
    Test_Taker_User_Id : string;
    Is_Logged : string;
    login_time: string;
    logoff_time: string;
    // options:Array<Overall_Result>;
  }

  export interface evaluate_user{
    id:string;
  }
  export interface formData{
    data:string;
  }
  interface TokenResponse {
    token: string;

  }

@Injectable()
export class ConfigService {
    private token: string;

  constructor(private http: HttpClient) {}



  // public getData(user): Observable<any>{
  //
  //   const base = this.http.post('/users/displayimage',user);
  //   const request = base.pipe(
  //     map((data: TokenResponse) => {
  //
  //         return data;
  //     })
  //   );
  //   return request;
  // }





}


